import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const DropdownContainer = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ active }) => (active ? '100%' : 'auto')};
`

export const DropdownMenu = styled.div<{ active?: boolean }>`
  width: 100%;
  height: 48px;
  border: 1px solid ${colors.blue};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 11px;
  cursor: pointer;
`

export const DropDownSelected = styled.span`
  width: 251px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${({ color }) => color ?? `${colors.grayLight}`};
`

export const Label = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${colors.blue};
`

export const DropdownList = styled.ul`
  padding-top: 20px;
  height: 405px;
  width: 100%;
  list-style: none;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`

export const DropdownListItem = styled.li`
  background-color: ${colors.white};
  color: ${colors.blue};
  text-align: center;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px 40px;
  height: 40px;
  width: 300px;
  cursor: pointer;

  &:nth-child(odd) {
    background-color: ${colors.grayExtraLight};
  }

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }

  &:hover {
    background-color: ${colors.blue};
    color: ${colors.white};
  }
`

export const Container = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;
`
export const Icon = styled.img`
  width: 70px;
  height: 70px;
`

export const Text = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.blue};
  text-align: center;
`

export const SubText = styled.p`
  font-size: 14px;
  color: ${colors.grayDark};
  text-align: center;

  margin-top: 15px;
`
